import { numberWithCommas } from "utils/Utils"
import { textBold, tdTextSupfix } from "utils/Constant"
import { removeItem } from 'proptypes/ArrayProptype';

// This function is use to convert the data to represent the table like
//(Profit & Loss,Quarterly Results,Balance Sheet,Cash Flows,Du Pont)
export const convertDataBasedOnDate = (data, unWantedKeys) => {
    let columnRows = []
    let rows = []
    let columnHeaders = []
    let rowHeaders = []

    let rowsAsOnDate = data && data.map((item, index) => {
        if (index === 0) {
            Object.keys(item).map((key) => {
                columnRows.push(key)
                return this
            })
        }
        let row = {}
        rowHeaders.push(item.as_on_date)
        row[item.as_on_date] = item
        return row
    })

    unWantedKeys.forEach((key) => { columnRows = removeItem(columnRows, key); })

    columnRows.map((columnRow, index) => {
        let row = { "PARTICULARS": columnRow, }
        rowsAsOnDate.map((date, index) => {
            row[rowHeaders[index]] = textBold[columnRow] ?
                <b>{numberWithCommas(date[rowHeaders[index]][columnRow])}</b>
                : tdTextSupfix[columnRow] ?
                    numberWithCommas(date[rowHeaders[index]][columnRow]) + '%'
                    : numberWithCommas(date[rowHeaders[index]][columnRow])

            return null
        })
        rows.push(row)
        return null
    })
    columnHeaders = rows.length && Object.keys(rows[0]).map((item) => { return { field: item } })

    return { columnHeaders, rows }
}

// This function is use to convert the data to represent the table lke
//(Peer Comparison)
export const convertDataBasedOnCompany = (data, unWantedKeys) => {

    let rowHeaders = []
    let columnHeaders = []
    let rows = []

    let companies = data ? Object.keys(data) : []
    if (data && companies.length > 0) {
        rowHeaders = Object.keys(data[companies[0]])
        unWantedKeys.forEach((key) => { rowHeaders = removeItem(rowHeaders, key); })
    }
    companies.map((company, index) => {
        let row = {}
        rowHeaders.map((header, index) => {
            row[header] = index === 0 ? data[company][header] : numberWithCommas(data[company][header])
            return null
        })
        rows.push(row)
        return null
    })
    columnHeaders = rows.length && Object.keys(rows[0]).map((item) => { return { headerName: item } })

    return { columnHeaders, rows }
}

// This function is use to convert the data to represent the table like
//(DCF Analysis)
export const convertDataBasedOnYear = (data) => {
    let rows = []
    let rowHeaders = []
    let columnHeaders = []

    let years = data.length !== 0 ? Object.keys(data) : []
    if (data && years.length > 0) {
        rowHeaders = Object.keys(Object.values(data)[0])
    }
    years.map((year, index) => {
        let row = { "YEAR": year }
        rowHeaders.map((header, index) => {
            if (header === 'fcf' || header === 'present_value') {
                row[header] = '₹ ' + numberWithCommas(data[year][header])
            }
            else {
                row[header] = numberWithCommas(data[year][header]) + ' %'
            }
            return null
        })
        rows.push(row)
        return null
    })

    columnHeaders = rows.length && Object.keys(rows[0]).map((item) => {
        return {
            analysisName: item
        }
    })
    return { columnHeaders, rows }
}

// This function is use to convert the data to represent the table like
//(Ratios Table)
export const convertRatiosDataBasedonYear = (data) => {
    let columnRows = data.map((item) => Object.keys(item)[0])
    let rows = []
    let columnHeaders = []
    // eslint-disable-next-line
    data.map((item, index) => {
        let row = { "Ratios/Years": columnRows[index] }
        // eslint-disable-next-line
        item[columnRows[index]].data.map((x) => {
            row[x.as_on_date] = numberWithCommas(x.value)
        })
        row['meta_data'] = item[columnRows[index]].meta_data
        row['AHL'] = item[columnRows[index]].AHL
        rows.push(row)
    })
    columnHeaders = rows.length && Object.keys(rows[0]).map((item) => { return { field: item } })
    return { columnHeaders, rows }
}
